import React, { useEffect } from 'react';
import config from '../config'; // assuming your env config is in src/config.js
console.log("✅ Signup URL from config:", config.signUpUrl);
const Signup = () => {
  useEffect(() => {
    const hasOpened = sessionStorage.getItem('signupOpened');

    if (!hasOpened) {
      window.open(config.signUpUrl, '_blank');
      sessionStorage.setItem('signupOpened', 'true');
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white flex-col text-center px-6">
      <h1 className="text-3xl font-bold text-gray-800">Redirecting you to the Signup Page...</h1>
      <p className="text-gray-600 mt-4">
        If the page didn't open automatically,<br />
        <a
          href={config.signUpUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-semibold underline hover:text-blue-800 transition"
        >
          Click here to sign up
        </a>
      </p>
    </div>
  );
};

export default Signup;
